module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 volume = volume*1000 ;
__p += '\n';
 solidVolume = solidVolume * 1000 ;
__p += '\n';
 temperature = temperature - 273.15 ;
__p += '\n';
 if (!pour){ ;
__p += '\n';
 topCy= 118.4- (.1408*volume) ;
__p += '\n';
 rectHeight= .1408*volume ;
__p += '\n';
 rectY= 118.4-.1408*volume ;
__p += '\n<svg xmlns="http://www.w3.org/2000/svg" height="130" width="71.68" viewBox="0 0 71.68 130" version="1.2">\n    <defs>\n        <clipPath id="a">\n            <path d="M3.84 33.92H64v84.48H3.84z"/>\n            <ellipse ry="9.6" rx="30.08" cy="118.4" cx="33.92"/>\n        </clipPath>\n    </defs>\n    <g fill="none" stroke="#1e1e1e" stroke-width=".13" stroke-linecap="round" stroke-linejoin="round">\n        <path d="M8.094 120.82c0-2.056 4.436-3.868 11.185-4.94M26.817 115.067c2.14-.137 4.393-.211 6.719-.211 14.05 0 25.442 2.67 25.442 5.963M23.244 110.342a96.503 96.503 0 0110.292-.537c12.086 0 22.484 2.107 27.096 5.128M6.44 114.933c1.654-1.083 3.797-1.955 6.664-2.75" stroke-width=".416"/>\n    </g>\n    ';
 if (volume > solidVolume) { ;
__p += '\n    <g opacity=".4">\n        <ellipse ry="9.6" rx="30.08" cy="' +
((__t = (topCy)) == null ? '' : __t) +
'" cx="33.92" fill="' +
((__t = (color)) == null ? '' : __t) +
'"/>\n        <g opacity=".6" fill="' +
((__t = (color)) == null ? '' : __t) +
'">\n            <rect width="60.16" height="' +
((__t = (rectHeight)) == null ? '' : __t) +
'" x="3.84" y="' +
((__t = (rectY)) == null ? '' : __t) +
'" />\n            <ellipse ry="9.6" rx="30.08" cy="118.4" cx="33.92"/>\n        </g>\n    </g>\n    ';
 } ;
__p += '\n    ';
 if (solidVolume > 0) { ;
__p += '\n        <circle clip-path="url(#a)" r="';
print(Math.pow(solidVolume,1/3)*6);
__p += '" cy="127" cx="33.92" fill="' +
((__t = (solidColor)) == null ? '' : __t) +
'"/>\n    ';
 } ;
__p += '\n    <g fill="none" stroke-linecap="round" stroke-linejoin="round">\n        <path d="M56.966 123.664c4.026-1.9 4.948-4.305 4.948-6.337M5.19 117.327c0 4.063 3.662 9.627 28.33 9.627 8.492 0 14.494-.66 18.715-1.691" stroke="#1e1e1e" stroke-width=".416"/>\n        <path d="M15.294 105.475c1.842.403 3.884.751 6.085 1.033V43.197a71.09 71.09 0 01-6.085-1.033" stroke="#000" stroke-width=".6944"/>\n        <path d="M68.79 14.452c-.398-.256-1.303-.518-1.727-.598-3.423-.65-5.787-.52-9.878.414-5.89 1.345-14.028 2.177-23.017 2.177-13.184 0-24.058-1.894-29.2-4.377-1.24-.599-1.902-1.415-2.034-2.006" stroke="#323232" stroke-width=".5568"/>\n        <path d="M3.432 16.562v101.692c0 4.125 3.89 11.04 30.093 11.04 26.202 0 30.092-6.915 30.092-11.04V22.831s-.363-5.588 4.947-6.352c.266-.038 1.119.339 1.413.328 1.702-.065 2.094-2.037-.723-4.685-3.135-2.946-1.664-6.18-7.894-8.38C55.393 1.638 45.19-.012 33.525-.012 15.212-.013.368 3.73.368 8.215c0 3.25 3.064 3.581 3.064 8.347z" stroke="#323232" stroke-width=".6944"/>\n        <path d="M21.379 64.25a70.685 70.685 0 01-6.085-1.034M21.379 85.345a70.828 70.828 0 01-6.085-1.033" stroke="#000" stroke-width=".5568"/>\n        <path d="M65.928 15.285c-4.123-.446-5.251.046-8.81.948-.234.06-.476.12-.73.183M3.818 13.61c5.483 3.371 17.15 5.19 29.718 5.19 6.534 0 12.628-.494 17.765-1.346M15.545 3.706c-4.87.909-9.305 2.44-11.074 3.64-.812.552-1.282 1.188-1.282 1.937M65.601 11.488C64.55 8.904 63.94 6.77 58.143 5.047 52.162 3.269 43.565 2.154 34.01 2.154c-4.734 0-9.235.273-13.297.766" stroke="#1e1e1e" stroke-width=".2784"/>\n    </g>\n</svg>\n';
 } ;
__p += '\n';
 if (pour){ ;
__p += '\n';
 topCx = 32.64 + .0448 * volume ;
__p += '\n';
 topCy = 108.8 - .11968 * volume ;
__p += '\n';
 polyAx = topCx - 32 ;
__p += '\n';
 polyAy = topCy ;
__p += '\n';
 polyBx = topCx + 32 ;
__p += '\n';
 polyBy = topCy ;
__p += '\n<svg xmlns="http://www.w3.org/2000/svg" height="133.76" width="100.48" viewBox="0 0 100.48 133.76" version="1.2">\n    <defs>\n        <clipPath id="a">\n            <path fill="#434" opacity=".6" d="M27.52 36.992L.64 108.8l56.96 21.12 33.92-92.928z"/>\n            <ellipse ry="9.6" rx="30.08" cy="119.36" cx="29.12" transform="rotate(20 29.12 119.36)" fill="#434"/>\n        </clipPath>\n    </defs>\n    <g fill="none" stroke="#1e1e1e" stroke-width=".13" stroke-linecap="round" stroke-linejoin="round">\n        <path d="M4.404 111.478c.703-1.932 5.49-2.117 12.2-.816M23.965 112.476c2.059.603 4.2 1.304 6.386 2.1 13.203 4.805 22.994 11.21 21.868 14.305M22.224 106.814a96.503 96.503 0 019.854 3.015c11.358 4.134 20.408 9.671 23.709 14.087M4.862 105.381c1.925-.452 4.237-.538 7.203-.304" stroke-width=".416"/>\n    </g>\n    ';
 if (volume > solidVolume) { ;
__p += '\n    <g opacity=".4">\n        <ellipse ry="9.6" rx="32" cy="' +
((__t = ( topCy )) == null ? '' : __t) +
'" cx="' +
((__t = ( topCx )) == null ? '' : __t) +
'" fill="' +
((__t = (color)) == null ? '' : __t) +
'"/>\n        <g opacity=".6" fill="' +
((__t = (color)) == null ? '' : __t) +
'">\n            <polygon points="' +
((__t = (polyAx)) == null ? '' : __t) +
' ' +
((__t = (polyAy)) == null ? '' : __t) +
' .64 108.8 57.6 129.92 ' +
((__t = (polyBx)) == null ? '' : __t) +
' ' +
((__t = (polyBy)) == null ? '' : __t) +
'"/>\n            <ellipse ry="9.6" rx="30.08" cy="119.36" cx="29.12" transform="rotate(20 29.12 119.36)"/>\n        </g>\n    </g>\n    ';
 } ;
__p += '\n    ';
 if(solidVolume > 0) { ;
__p += '\n        <circle clip-path="url(#a)" r="';
print(Math.pow(solidVolume,1/3)*6);
__p += '" cy="118.36" cx="29.12" fill="' +
((__t = (solidColor)) == null ? '' : __t) +
'"/>\n    ';
 } ;
__p += '\n    <g fill="none" stroke-linecap="round" stroke-linejoin="round">\n        <path d="M49.356 130.866c4.433-.407 6.122-2.353 6.817-4.262M2.87 107.203c-1.39 3.818.148 10.299 23.327 18.735 7.98 2.905 13.847 4.338 18.166 4.812" stroke="#1e1e1e" stroke-width=".416"/>\n        <path d="M16.417 99.522a70.796 70.796 0 005.365 3.052L43.436 43.08a71.09 71.09 0 01-5.365-3.052" stroke="#000" stroke-width=".6944"/>\n        <path d="M97.818 32.285c-.286-.377-1.046-.932-1.417-1.153-2.994-1.782-5.26-2.468-9.424-2.99-5.995-.75-13.926-2.752-22.373-5.826-12.39-4.51-21.96-10.008-25.943-14.1-.96-.987-1.303-1.98-1.225-2.58" stroke="#323232" stroke-width=".5568"/>\n        <path d="M35.681 11.914l-34.78 95.56c-1.411 3.875-.12 11.703 24.501 20.665 24.622 8.961 30.643 3.795 32.054-.081l32.636-89.669s1.57-5.375 6.822-4.277c.262.055.935.701 1.216.791 1.62.522 2.663-1.197.922-4.65-1.939-3.84.55-6.376-4.552-10.573-4.887-4.02-13.91-9.06-24.872-13.05C52.42.367 37.19-1.192 35.656 3.022c-1.111 3.054 1.655 4.414.025 8.892z" stroke="#323232" stroke-width=".6944"/>\n        <path d="M36.236 62.863a70.685 70.685 0 01-5.365-3.052M29.02 82.687a70.828 70.828 0 01-5.364-3.052" stroke="#000" stroke-width=".5568"/>\n        <path d="M94.845 32.088c-3.722-1.828-4.95-1.752-8.604-2.122l-.748-.077M37.054 9.271c3.999 5.044 14.34 10.743 26.15 15.042 6.14 2.235 12.036 3.855 17.154 4.811M51.46 3.976c-4.886-.811-9.578-.89-11.65-.367-.952.24-1.612.678-1.868 1.382M95.837 28.409c-.106-2.789.05-5.002-4.806-8.604C86.02 16.09 78.321 12.1 69.343 8.833c-4.449-1.62-8.771-2.902-12.757-3.828" stroke="#1e1e1e" stroke-width=".2784"/>\n    </g>\n</svg>\n';
 } ;
__p += '\n<div class= "vesselInfo"\n    ';
 if (pour) { ;
__p += '\n     style="text-align:left;"\n    ';
 } ;
__p += '\n    >\n    <div class = "vesselName">\n        ' +
((__t = (name)) == null ? '' : __t) +
' <br>\n    </div>\n    ';
 if (showVesselStats) { ;
__p += '\n    <div class = "vesselStats" >\n        ' +
((__t = ( volumeString )) == null ? '' : __t) +
' @</small> ' +
((__t = (temperature.toLocaleString(language, {maximumSignificantDigits: 3, minimumSignificantDigits: 3}))) == null ? '' : __t) +
'&deg;C</sub>\n    </div>\n    ';
 } ;
__p += '\n</div>';

}
return __p
}